import './Correspondence.css'

export default function Correspondence() {
    return (
        <section id='contact' className='correspondence'>
            <div className='letter' data-reveal>
                <p className='letter-kicker'>§ 04 — Correspondence</p>
                <h2 className='letter-title'>Let's work<br/><em>together!</em></h2>
                <div className='letter-actions'>
                    <a className='letter-btn letter-btn-primary' href="https://wa.me/0111536332941?text=Hi!%20I'm%20interested%20in%20getting%20in%20touch%20with%20you" target='_blank' rel='noreferrer'>Send a message →</a>
                    <a className='letter-btn' href='https://github.com/Victoria-Lopez-dev' target='_blank' rel='noreferrer'>GitHub</a>
                    <a className='letter-btn' href='https://www.linkedin.com/in/m-victoria-lopez/' target='_blank' rel='noreferrer'>LinkedIn</a>
                </div>
            </div>
        </section>
    )
}
